import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { toolbarInsertBlockMessages } from '@atlaskit/editor-common/messages';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import { Box, Pressable, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
var wrapperStyles = xcss({
  width: '32px',
  height: '32px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});
var buttonStyles = xcss({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: "var(--ds-space-300, 24px)",
  width: "var(--ds-space-300, 24px)",
  border: 'none',
  backgroundColor: 'color.background.neutral.subtle',
  borderRadius: 'border.radius.circle',
  color: 'color.text',
  zIndex: 'card',
  outline: 'none',
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.pressed'
  },
  ':focus': {
    outline: "2px solid ".concat("var(--ds-border-focused, #388BFF)")
  }
});
var disabledStyles = xcss({
  color: 'color.text.disabled',
  backgroundColor: 'color.background.neutral.subtle',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.subtle'
  }
});
var activeStyles = xcss({
  backgroundColor: 'color.background.selected',
  color: 'color.text.selected',
  ':hover': {
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected'
  }
});
export var RightRailIcon = function RightRailIcon(_ref) {
  var onClick = _ref.onClick,
    isDisabled = _ref.isDisabled,
    api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginState(api, ['insertBlock']),
    insertBlockState = _useSharedPluginState.insertBlockState;

  // @ts-expect-error
  var isOpen = insertBlockState === null || insertBlockState === void 0 ? void 0 : insertBlockState.menuBrowserOpen;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: [wrapperStyles]
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement(ToolTipContent
    // Re-using insertRightRailTitle for tooltip, both messages are the same
    , {
      description: formatMessage(toolbarInsertBlockMessages.insertRightRailTitle),
      shortcutOverride: "/"
    })
  }, /*#__PURE__*/React.createElement(Pressable, {
    type: "button",
    "aria-label": formatMessage(toolbarInsertBlockMessages.insertMenu),
    xcss: [buttonStyles, isDisabled ? disabledStyles : undefined, isOpen ? activeStyles : undefined],
    onClick: onClick,
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(EditorAddIcon, {
    label: formatMessage(toolbarInsertBlockMessages.insertMenu),
    size: "medium"
  }))));
};